import { ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { rage } from '~/rage';
import { ShopLogo } from '../ShopLogo';
import { StyledContainer, StyledRightContainer } from './Head.styled';

const Head = () => {
	return (
		<StyledContainer>
			<ShopLogo />
			<StyledRightContainer>
				<ShopBalance />
				<CloseButton
					height={ButtonHeight.Height40}
					iconSize={20}
					onClick={() => rage.vehicleTuningShop.exitMenu()}
				/>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Head };
